import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import PhotoCard from "./PhotoCard";

const stories = {
  Tsung_Chien: {
    id: "albumTsungChien",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/5e436579787593.5cce06b1f3520.jpg",
    title: "Tsung & Chien",
    subtitle: "Nationaal Park De Hoge Veluwe",
  },
  Herbert_Hilda: {
    id: "albumHerbertHilda",
    url: "https://mir-cdn.behance.net/v1/rendition/project_modules/2800_opt_1/de583c79787757.5d30b6da82b40.jpg",
    title: "Herbert & Hilda",
    subtitle: "Utrecht",
  },
  Tim_Ginny: {
    id: "albumTimGinny",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/fs/1bfef275725251.5c802551d2266.jpg",
    title: "Tim & Ginny",
    subtitle: "Zoeterwoude",
  },
  Marco_Wiola: {
    id: "albumMarcoWiola",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d8f33d75843643.5c5881e5c9a57.jpg",
    title: "Marco & Wiola",
    subtitle: "Delftse Hout",
  },
  William_Min: {
    id: "albumWilliamMin",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1d35f775852371.5c58b02982bbc.jpg",
    title: "William & Min",
    subtitle: "Delft",
  },
  YuChou_YuWen: {
    id: "albumYuChouYuWen",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/fs/77e9f8130801465.6190118032aae.jpg",
    title: "Yu Chou & Yu Wen",
    subtitle: "Delft",
  },
  Luca_William_engagement: {
    id: "albumWilliamLucaEngagement",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/cb69c6173317965.648e201212b60.jpg",
    title: "William & Luca",
    subtitle: "Utrecht Engagement",
  },
  Luca_William_wedding: {
    id: "albumWilliamLucaWedding",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/fs/84a151191289689.65c92c4721123.jpg",
    title: "William & Luca",
    subtitle: "Utrecht Wedding",
  },
  PoJu_Polly: {
    id: "albumPoJuPolly",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/384d2b75852797.5c58b300964b5.jpg",
    title: "Po Ju & Polly",
    subtitle: "Delft",
  },
  Danny_FangJu: {
    id: "albumDannyFangJu",
    url: "https://mir-s3-cdn-cf.behance.net/project_modules/fs/2bc0cc179088259.64f36af9cdc45.jpg",
    title: "Danny & Fang Ju",
    subtitle: "Delft",
  },
};

export default function ContentGrid(props) {
  const { setSelectedAlbumId } = props;
  const theme = useTheme();

  return (
    <Box
      pl={{ xs: theme.spacing(0), md: theme.spacing(20) }}
      pr={{ xs: theme.spacing(0), md: theme.spacing(20) }}
    >
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6}>
          <PhotoCard
            story={stories.Luca_William_engagement}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.Danny_FangJu}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.Tim_Ginny}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.Tsung_Chien}
            setSelectedAlbumId={setSelectedAlbumId}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PhotoCard
            story={stories.Luca_William_wedding}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.YuChou_YuWen}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.Marco_Wiola}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.William_Min}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          <PhotoCard
            story={stories.Herbert_Hilda}
            setSelectedAlbumId={setSelectedAlbumId}
          />
          {/* <PhotoCard
            story={stories.PoJu_Polly}
            setSelectedAlbumId={setSelectedAlbumId}
          /> */}
        </Grid>
      </Grid>
    </Box>
  );
}
